export default ({...props}) => {
  const {palette, space, shape, size, themeGrey} = props.theme

  const {borderRadius} = shape
  return `
   &[ap_atom_name="textfieldAtom"]{
      width: ${size(12.5)}%;
      & > .MuiFormLabel-root{
        color: ${themeGrey.medium_emphasis_grey}; 
        margin-left:${space(2)}px; 
        transform: translate(0, ${space(2.5)}px) scale(1);

        &.MuiInputLabel-shrink{
          transform: translate(0,${space(0.875)}px) scale(0.75);
        }
      }
      & > .MuiInputLabel-shrink{
        color:${themeGrey.medium_emphasis_grey};
        &:after {
            border-bottom:1px solid ${palette.common.black};
          }
        &.Mui-focused{
          color:${themeGrey.medium_emphasis_grey};
        }
      }
      & > .MuiInputBase-formControl:not(.MuiInputBase-multiline):not(.Mui-error):after {
        border-bottom: 1px solid ${themeGrey.medium_emphasis_grey};
      }
      &>.MuiFormHelperText-root{
        margin-left:${space(2)}px;
        margin-right:${space(2)}px;
        @media screen and (max-width: 769px)  {
          margin-left:${space(0)}px;
          margin-right:${space(0)}px;
        }
      }
      & .MuiFilledInput-input:after{
            border-Bottom:1px solid ${palette.error.dark};
        }
      & .Mui-error{
        color: ${palette.error.dark};
        &:after {
          border-bottom:1px solid ${palette.error.dark};
        }
      } 
      & > .MuiInputBase-formControl:not(.MuiInputBase-multiline){
        height: ${size(7)}px;
         background: ${themeGrey.input_active};
          &:before {
          border-bottom: 1px solid ${palette.common.black};
        }
      & > .MuiInputBase-input {
         padding-bottom:${size(1)}px;
          padding-top:${size(3)}px;
         }
       }
      & > .MuiInputBase-formControl{
        background: ${palette.common.white};
        border-radius: ${borderRadius}px ${borderRadius}px 0px 0px;
        opacity: 1;
        font: normal normal normal 16px/21px Roboto;
        caret-color: ${palette.common.black};
        & > .MuiInputBase-input {
          padding:${size(2)}px;
          max-width: -webkit-fill-available;
        }
        &> .MuiFilledInput-input{
          color:${palette.text.primary};
        }
        &.Mui-disabled {
          background:${themeGrey.input_disabled};
          &:before {
            border-bottom: 1px solid ${themeGrey.disabled_grey};
          }
        }
      }
      & .Mui-error.MuiInputBase-formControl.MuiInputBase-multiline {
        border-color: ${palette.error.main};
      }

      @media screen and (max-width: 501px) {
        display: flex;
        > div {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          > textarea {
            flex-grow: 1;
            display: flex;
            height: auto;
            width: calc(100% - ${size(4)}px);
          }
        }
      }
    }
  `
}
